import React, { ReactNode, useState } from "react";
import {
  Box,
  Button,
  Avatar,
  Typography,
  Tabs,
  Tab,
  Container,
  Divider,
  FormControl,
  InputLabel,
  TextField,
  useMediaQuery, // Import the useMediaQuery hook
  Theme,
  styled,
  ButtonProps,
  useTheme,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import TabPanel, {
  a11yProps,
} from "../../../Shared-ui/SharedComponents/TabPanel";
import UsersData from "../../Components/UserMangement";
import variables from "../../../assets/styles/variables.module.scss";
import CreateUser from "../../Components/CreateUser";
import { User } from "../../../Shared-ui/Types/User";
import { userInitial } from "../../../Shared-ui/Store/UserReducer/UserReducer";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

interface MyComponentProps { }

const AdminUserManagement: React.FC<MyComponentProps> = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [tabValue, setTabValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null)



  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleOpen = () => {
    setUser(null)
    setOpen(true);
  };

  const handleClose = () => {
    setUser(null);
    setOpen(false);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Users", path: "" }]} />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
          }}
        >
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              fontWeight: "400",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
            }}
            onClick={handleOpen}
          >
            Add User
          </ColorButton>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            height: "100%",
            gap: 4,
          }}
        >
          <Box
            sx={{
              width: "100%",
            }}
          >
            <UsersData setOpen={setOpen} setUser={setUser} open={open}/>
          </Box>
        </Box>
      </Box>
      <CreateUser open={open} handleClose={handleClose} user={user} />
    </Container>
  );
};

export default AdminUserManagement;